/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SuggestedArticlesRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SuggestedArticlesResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const suggestedArticles = (request: SuggestedArticlesRequest, options?: CashRequestOptions) => post<SuggestedArticlesRequest, SuggestedArticlesResponse>("/2.0/cash/suggested-articles", request, {...options, rejectOnError: true })